import { getUserFromToken } from '@/services/auth'
import { useUserStore } from '@/store/userStore'
import { reactive } from 'vue'
import { type User } from '@/types'

// let isInitialized = false // ✅ Prevents multiple calls

export function useUser() {
  const user = reactive<User>({
    id: '',
    first_name: '',
    last_name: '',
    email: '',
    tenant_id: '',
    tenant_name: '',
    company_name: '',
    roles: []
  })

  const userStore = useUserStore()

  async function initializeUser() {
    
    // TODO: add an expired check as well
    if (user.id) return
    
    const tokenUser = await getUserFromToken()
    if (tokenUser) {
      Object.assign(user, tokenUser) // ✅ Ensures reactivity
      await userStore.fetchUserDetails(user)
      
      user.company_name = userStore.extraUserData.company_name
      user.tenant_name = userStore.extraUserData.tenant_name
    }
  }


  function is_global_admin() : boolean  {
    
   
    const result = user.roles?.some(item => item.includes("aplos_nca:global:developer")
      || item.includes("aplos_nca:global:admin"))

    
    return result || false

  }

  function is_admin() : boolean  {
  
    const result = user.roles?.some(item => item.includes("aplos_nca:global:developer")
      || item.includes("aplos_nca:global:admin")) || user.roles?.includes("aplos_nca:tenant:admin")

    return result || false

  }

  return {
    user: user,          // ✅ No more computed()
    extraData: userStore.extraUserData,
    is_global_admin: is_global_admin,
    is_admin: is_admin,
    initialize: () => initializeUser(), // ✅ No direct `await` in return value,
    userSettings: userStore.userSettings
  }
}
